// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 491) return "static/chunks/491-852c0597db3a74c2.js";
	if (chunkId === 104) return "static/chunks/104-d36cedae5defff56.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"146":"datadog_browser_logs","340":"layout__client_site_chrome_ui","367":"layout__minimal","748":"datadog_browser_rum"}[chunkId] || chunkId) + "." + {"146":"cd095f010ccb5137","205":"2e90144ef4045da8","319":"0cbc2894a3f1b950","340":"20d8b72772f99f86","367":"5d183dbb662b6516","639":"6f30bd92b2c07e9c","748":"c24e8725950da7e9"}[chunkId] + ".js";
};